import { Component, OnInit, signal, ChangeDetectionStrategy, DestroyRef, inject, input, output } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ISurveyQuestion } from "../../../models/IRating";
import { ThemeService } from "../../../services/theme.service";
import { RatingScoreItem } from "@auvious/rating";
import { ISurveyQuestionForm } from "../survey.component";

@Component({
  selector: "app-survey-score",
  templateUrl: "./score.component.html",
  styleUrls: ["./score.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SurveyScoreComponent
  implements OnInit, ISurveyQuestionForm
{
  private themeService = inject(ThemeService);
  private destroyRef = inject(DestroyRef);

  readonly question = input<ISurveyQuestion>(undefined);

  readonly changed = output<RatingScoreItem>();

  item = signal<RatingScoreItem>(undefined);
  hoverRating = signal(0);
  points: number[] = [];
  isDarkMode = signal(false);
  isTypeStar = false;
  isError = signal(false);

  ngOnInit(): void {
    const question = this.question();
    this.item.set({
      ...question,
      rating: null,
    });

    this.isTypeStar = question.visual === "stars";

    const max = this.item().type === "RATING_1_10" ? 10 : 5;
    const min = 1;
    for (var i = min; i <= max; i++) {
      this.points.push(i);
    }

    this.themeService.themeChanged$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((theme) => {
        this.isDarkMode.set(theme.darkMode);
      });
  }

  rate(point) {
    this.isError.set(false);
    this.item.update((item) => ({ ...item, rating: point }));
    this.changed.emit(this.item());
  }

  empty() {
    this.hoverRating.set(0);
  }

  fill(point) {
    this.hoverRating.set(point);
  }

  isActive(point) {
    return this.hoverRating() >= point || this.item().rating >= point;
  }

  isValid() {
    return this.item().rating !== null;
  }

  markAsTouched() {
    this.isError.set(true);
  }
}
